import moment from "moment";

export const DATE_FORMAT = 'DD MMM YYYY';
export const DATE_INPUT_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'DD MMM YYYY HH:MM';

export const toDateInputStr = date => date ? moment(date).format(DATE_INPUT_FORMAT) : undefined;
export const toDateStr = date => moment(date).format(DATE_FORMAT);
export const toDateTimeStr = date => moment(date).format(DATE_TIME_FORMAT);
